import { RoomType } from '../domain/types';
import { kitchenTypeLabels } from './kitchenTypeLabels';
import { propertyMainRoomLabels } from './propertyMainRoomLabels';

export const propertyRoomLabels: Record<RoomType, string> = {
  ...propertyMainRoomLabels,
  ...kitchenTypeLabels,
};
